import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const emptyIconWrapper: SxStyle = {
  padding: (p) => p.spacing(3),
};
